var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-badge',{attrs:{"color":"secondary","inline":"","content":String(_vm.value),"value":_vm.value !== undefined}})}
var staticRenderFns = []

export { render, staticRenderFns }